import React from 'react';
import { Table } from 'reactstrap';
import MaterialIcon from 'material-icons-react';

const CustomerAddressTable = ({ addresses }) => {

    const renderAddresses = () => {
        return addresses.map(address => {
            return (
                <tr>
                    <td>
                        <MaterialIcon icon="room" size={18} color="color: 'rgb(128,128,128)'" />
                        {address}
                    </td>
                </tr>
            );
        })
    }

    return (
        <Table hover striped >
            <tbody>
                {renderAddresses()}
            </tbody>
        </Table>

    );
}

export default CustomerAddressTable;


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerAddressTable.js